import { createContext as r, useState as d, useMemo as n } from "react";
import { u } from "./use-unique-id-BA9hSqap.js";
const c = r({});
c.displayName = "CardContext";
const p = ({
  id: e,
  surface: a = "white"
}) => {
  const o = u("card", e), [t, s] = d({
    id: o,
    surface: a
  });
  return [n(
    () => ({
      ...t
    }),
    [t]
  ), s];
};
export {
  c as C,
  p as u
};
//# sourceMappingURL=CardContext-B6h__heb.js.map
